import React, {Component} from 'react';
import './Product.css';
import {baseURL} from './../../config';


class Product extends Component {

  constructor(props) {
    super(props);
    this.state = {};
  }

  getProduct({packs, match:{params:{packageID, productID}}}) {
    let pack, product = null;
    pack = packs.find(pack => (pack.id == packageID) );
    if(pack) {
        product = pack.products.find(product => (product.id == productID) );
    }
    return product;

  }

  render() {
    // const {skreen, packs} = this.props;
    let output = <div>{this.props.match.params.productID}</div>;
    console.log("pr render", this.props);
    const product = this.getProduct(this.props);

    if(product){
    output = (
      <div className="product">
        <div className="product-image">
        <img style={{width:'100%'}} src={`${baseURL}/images/products/${product.picture}`} />
        </div>
        <div className="product-info">
          <p className="product-title">Women's Sports Shoes Damping Encapsulated Chic All Match Shoes</p>
          <p className="product-hash-tag">#349WSB90APJ3L</p>
          <div className="product-price--bonus">
            <div className="price--review">
              <p className="price"><span>{product.price} SAR</span></p>
              <div className="review">10102 Review</div>
            </div>
            <div className="bonus">
              <ul className="services-list">
                <li className="services-list-item">
                  <img width="24px" src={`${baseURL}/icons/service.png`} />
                  <span>Free Return</span>
                </li>
                <li className="services-list-item">
                  <img width="24px" src={`${baseURL}/icons/service.png`} />
                  <span>Free&Express Delivery</span>
                </li>
                <li className="services-list-item">
                  <img width="24px" src={`${baseURL}/icons/service.png`} />
                  <span>Cash on Delivery</span>
                </li>
              </ul>
            </div>
          </div>
          <div className="attr">

            <div className="color">
              <div className="title">Color</div>
              <div className="items">
                <div className="item">
                  <span>
                    <img src={`${baseURL}/images/products/colors/black.jpg`}></img>
                  </span>
                </div>
                <div className="item">
                  <span>
                    <img src={`${baseURL}/images/products/colors/white.jpg`}></img>
                  </span>
                </div>
                <div className="item">
                  <span>
                    <img src={`${baseURL}/images/products/colors/pink.jpg`}></img>
                  </span>
                </div>
                <div className="item">
                  <span>
                    <img src={`${baseURL}/images/products/colors/grey.jpg`}></img>
                  </span>
                </div>
              </div>
            </div>

            <div className="size">
              <div className="title">Size</div>
              <div className="items">
                <div className="item">
                  <span>35</span>
                </div>
                <div className="item">
                  <span>36</span>
                </div>
                <div className="item">
                  <span>37</span>
                </div>
                <div className="item">
                  <span>38</span>
                </div>
                <div className="item">
                  <span>39</span>
                </div>
                <div className="item">
                  <span>40</span>
                </div>
                <div className="item">
                  <span>41</span>
                </div>
                <div className="item">
                  <span>42</span>
                </div>
              </div>
            </div>

          </div>
          <span className="add-to-bag">ADD TO BAG</span>
        </div>
      </div>
    );
    }
    return output;
  }
}

export default Product;
